export default __webpack_public_path__ + "static/media/Image2.1371ada2.png";